import axios from "axios";
import { getValidToken } from "./getValidToken";

const api = axios.create();

api.interceptors.request.use(
  async (config) => {
    const token = await getValidToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;

    if (
      error.response?.status === 401 &&
      originalConfig &&
      !originalConfig._retriedAfter401
    ) {
      originalConfig._retriedAfter401 = true;
      try {
        // Access token was rejected — force-refresh once and replay the call
        const token = await getValidToken({ forceRefresh: true });
        originalConfig.headers.Authorization = `Bearer ${token}`;
        return api(originalConfig);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
